/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Offercard_Owned1Inputs */

const id_components_offercard_owned1 = /** @type {(inputs: Components_Offercard_Owned1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dimiliki`)
};

const ms_components_offercard_owned1 = /** @type {(inputs: Components_Offercard_Owned1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dimiliki`)
};

const da_components_offercard_owned1 = /** @type {(inputs: Components_Offercard_Owned1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ejet`)
};

const de_components_offercard_owned1 = /** @type {(inputs: Components_Offercard_Owned1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`im Besitz`)
};

const en_us2_components_offercard_owned1 = /** @type {(inputs: Components_Offercard_Owned1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`owned`)
};

const es_es2_components_offercard_owned1 = /** @type {(inputs: Components_Offercard_Owned1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`en propiedad`)
};

const es_mx2_components_offercard_owned1 = /** @type {(inputs: Components_Offercard_Owned1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`en propiedad`)
};

const fil_components_offercard_owned1 = /** @type {(inputs: Components_Offercard_Owned1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pag-aari`)
};

const fr_components_offercard_owned1 = /** @type {(inputs: Components_Offercard_Owned1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`possédé`)
};

const it_components_offercard_owned1 = /** @type {(inputs: Components_Offercard_Owned1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`posseduto`)
};

const hu_components_offercard_owned1 = /** @type {(inputs: Components_Offercard_Owned1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`birtokolt`)
};

const nl_components_offercard_owned1 = /** @type {(inputs: Components_Offercard_Owned1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`in bezit`)
};

const no_components_offercard_owned1 = /** @type {(inputs: Components_Offercard_Owned1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`eid`)
};

const pl_components_offercard_owned1 = /** @type {(inputs: Components_Offercard_Owned1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`posiadane`)
};

const pt_br2_components_offercard_owned1 = /** @type {(inputs: Components_Offercard_Owned1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`owned`)
};

const pt_components_offercard_owned1 = /** @type {(inputs: Components_Offercard_Owned1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`possuído`)
};

const ro_components_offercard_owned1 = /** @type {(inputs: Components_Offercard_Owned1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`deținut`)
};

const fi_components_offercard_owned1 = /** @type {(inputs: Components_Offercard_Owned1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`omistettu`)
};

const sv_components_offercard_owned1 = /** @type {(inputs: Components_Offercard_Owned1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ägd`)
};

const vi_components_offercard_owned1 = /** @type {(inputs: Components_Offercard_Owned1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`đã sở hữu`)
};

const tr_components_offercard_owned1 = /** @type {(inputs: Components_Offercard_Owned1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sahip olunan`)
};

const cs_components_offercard_owned1 = /** @type {(inputs: Components_Offercard_Owned1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`vlastněno`)
};

const bg_components_offercard_owned1 = /** @type {(inputs: Components_Offercard_Owned1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`притежавано`)
};

const ru_components_offercard_owned1 = /** @type {(inputs: Components_Offercard_Owned1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`в библиотеке`)
};

const uk_components_offercard_owned1 = /** @type {(inputs: Components_Offercard_Owned1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`у власності`)
};

const ar_components_offercard_owned1 = /** @type {(inputs: Components_Offercard_Owned1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مملوكة`)
};

const hi_components_offercard_owned1 = /** @type {(inputs: Components_Offercard_Owned1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्वामित्व में`)
};

const th_components_offercard_owned1 = /** @type {(inputs: Components_Offercard_Owned1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เป็นเจ้าของแล้ว`)
};

const ja_components_offercard_owned1 = /** @type {(inputs: Components_Offercard_Owned1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`所有済み`)
};

const zh_cn2_components_offercard_owned1 = /** @type {(inputs: Components_Offercard_Owned1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`owned`)
};

const zh_hant1_components_offercard_owned1 = /** @type {(inputs: Components_Offercard_Owned1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`owned`)
};

const ko_components_offercard_owned1 = /** @type {(inputs: Components_Offercard_Owned1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`owned`)
};

/**
* | output |
* | --- |
* | "owned" |
*
* @param {Components_Offercard_Owned1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_offercard_owned1 = /** @type {((inputs?: Components_Offercard_Owned1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Offercard_Owned1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_offercard_owned1(inputs)
	if (locale === "ms") return ms_components_offercard_owned1(inputs)
	if (locale === "da") return da_components_offercard_owned1(inputs)
	if (locale === "de") return de_components_offercard_owned1(inputs)
	if (locale === "en-US") return en_us2_components_offercard_owned1(inputs)
	if (locale === "es-ES") return es_es2_components_offercard_owned1(inputs)
	if (locale === "es-MX") return es_mx2_components_offercard_owned1(inputs)
	if (locale === "fil") return fil_components_offercard_owned1(inputs)
	if (locale === "fr") return fr_components_offercard_owned1(inputs)
	if (locale === "it") return it_components_offercard_owned1(inputs)
	if (locale === "hu") return hu_components_offercard_owned1(inputs)
	if (locale === "nl") return nl_components_offercard_owned1(inputs)
	if (locale === "no") return no_components_offercard_owned1(inputs)
	if (locale === "pl") return pl_components_offercard_owned1(inputs)
	if (locale === "pt-BR") return pt_br2_components_offercard_owned1(inputs)
	if (locale === "pt") return pt_components_offercard_owned1(inputs)
	if (locale === "ro") return ro_components_offercard_owned1(inputs)
	if (locale === "fi") return fi_components_offercard_owned1(inputs)
	if (locale === "sv") return sv_components_offercard_owned1(inputs)
	if (locale === "vi") return vi_components_offercard_owned1(inputs)
	if (locale === "tr") return tr_components_offercard_owned1(inputs)
	if (locale === "cs") return cs_components_offercard_owned1(inputs)
	if (locale === "bg") return bg_components_offercard_owned1(inputs)
	if (locale === "ru") return ru_components_offercard_owned1(inputs)
	if (locale === "uk") return uk_components_offercard_owned1(inputs)
	if (locale === "ar") return ar_components_offercard_owned1(inputs)
	if (locale === "hi") return hi_components_offercard_owned1(inputs)
	if (locale === "th") return th_components_offercard_owned1(inputs)
	if (locale === "ja") return ja_components_offercard_owned1(inputs)
	if (locale === "zh-CN") return zh_cn2_components_offercard_owned1(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_offercard_owned1(inputs)
	return ko_components_offercard_owned1(inputs)
});
export { components_offercard_owned1 as "components.offerCard.owned" }